export default __webpack_public_path__ + "static/media/Search.8e58ad56.svg";